<template>
    <v-container class="pt-3 " fluid >
        <v-toolbar
                dense
                class="elevation-0"
                light
                color="blue-grey lighten-5"
        >
            <v-toolbar-title>Προσφορές</v-toolbar-title>

            <span class=" ml-1 subheading">Επισκόπηση</span>
            <v-spacer></v-spacer>
        </v-toolbar>
            <v-card>
                <v-layout wrap row  color="white" >
                    <v-flex xs12 md3>
                        <customers style="height: 100% " class="elevation-0 pa-3" ></customers>
                    </v-flex>
                    <v-flex xs12 md6 >
                        <relations class="elevation-0 pa-3"></relations>
                    </v-flex>
                    <v-flex xs12 md3  >
                        <offers class="elevation-0 pa-3" style="height: 100%" ></offers>
                    </v-flex>
                </v-layout>
            </v-card>


        <notifications group="messages" position="bottom right" width="300px"/>
        <v-card class="mt-4">
            <v-toolbar dense light color="blue-grey lighten-5" class="elevation-0">
                <v-toolbar-title> Δείτε τι έγινε Σήμερα </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-layout align-center justify-center >
                    <v-flex xs12 sm10 md10 >
                        <logs >
                        </logs>
                    </v-flex>
                </v-layout>
            </v-card-text>

        </v-card>
    </v-container>


</template>

<script>
    import StoreState from "@/assets/StoreState";
    import ApiData from "../assets/ApiData";
    import Offers from "../components/Offers";
    import Customers from "../components/Customers";
    import Relations from "../components/Relations";
    import Logs from "../components/Logs";


    export default {
        name: "Home",
        components: {Logs, Relations, Customers, Offers},
        data: function () {
            return {
                rowsPerPageItems: [10, 15, 25],
                pagination: {
                    rowsPerPage: 10
                },
            }
        },
        beforeMount() {
            if(StoreState.b2b.firstLoad){
                StoreState.messages.isLoading = true;
                StoreState.getB2bData().then(data => {
                    StoreState.messages.isLoading = false;
                    StoreState.b2b.firstLoad = false;
                });
            }
        },
        methods: {}

    }
</script>

<style scoped>
.scroll-x{
    max-height: 600px;
    overflow-y: auto;
}

</style>


// WEBPACK FOOTER //
// src/views/Home.vue